<template class="newList">
  <el-card class="box-card">
    <el-button class="btn" type="primary" icon="el-icon-arrow-left" @click="$router.go(-1)">返回</el-button>
    <el-form ref="dataForm" :model="dataForm" label-width="110px" :rules="dataFormRules" style="max-width: 1200px">
      <el-form-item prop="jobTypeId" label="工作类型">
        <el-select style="width: 100%" v-model="dataForm.jobTypeId" placeholder="请选择分类名称 " clearable>
          <el-option v-for="item in jobTypeNameList" :key="item.id" :label="item.typeName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="jobPositionId" label="岗位类型">
        <el-select style="width: 100%" v-model="dataForm.jobPositionId" placeholder="请选择分类名称 " clearable>
          <el-option v-for="item in jobPositionNameList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="title" label="招聘信息标题">
        <el-input style="width: 500px" v-model.trim="dataForm.title" placeholder="请输入招聘信息标题"></el-input>
      </el-form-item>
      <el-form-item prop="descStr" label="岗位描述">
        <div v-for="(item, index) in descStrList" :key="index"
          style="display: flex; align-items: center; margin-bottom: 10px">
          <el-input style="width: 1100px" v-model.trim="item.descStr" placeholder="请输入岗位描述"></el-input>
          <div style="width: 100px; margin-left: 10px">
            <el-button type="text" @click="deldescriptionListItem(index)">删除</el-button>
            <el-button type="text" @click="descStrList.push({ descStr: '' })"
              v-if="index == descStrList.length - 1">新增</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="jobRequirements" label="任职要求">
        <div v-for="(item, index) in jobRequirementsList" :key="index"
          style="display: flex; align-items: center; margin-bottom: 10px">
          <el-input style="width: 1100px" v-model.trim="item.jobRequirements" placeholder="请输入任职要求"></el-input>
          <div style="width: 100px; margin-left: 10px">
            <el-button type="text" @click="deljobRequirementsListItem(index)">删除</el-button>
            <el-button type="text" @click="jobRequirementsList.push({ jobRequirements: '' })"
              v-if="index == jobRequirementsList.length - 1">新增</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="workPlaceArr" label="工作地点">
        <el-select multiple style="width: 100%" v-model="dataForm.workPlaceArr" placeholder="请选择分类名称 " clearable>
          <el-option v-for="item in jobPlaceList" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
        <!-- <el-input
          style="width: 180px"
          v-model.trim="dataForm.workPlace"
          placeholder="请输入工作地点"
        ></el-input> -->
      </el-form-item>
      <el-form-item label="	招聘人数" prop="number">
        <el-input-number :min="1" placeholder="人数" v-model.trim="dataForm.number"></el-input-number>
      </el-form-item>
      <el-form-item prop="createTime" label="发布时间">
        <el-date-picker v-model.trim="dataForm.createTime" type="datetime" placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="置顶">
        <el-radio-group v-model="dataForm.top">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="$router.go(-1)">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag">保存并发布</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        workPlaceArr: [],
      },
      jobRequirementsList: [{}],
      descStrList: [{}],
      dataFormRules: {
        jobPositionId: [
          { required: true, message: "请输入岗位类型名称", trigger: "change" },
        ],
        jobTypeId: [
          { required: true, message: "请输入工作类型名称", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入招聘信息标题", trigger: "blur" },
        ],
        workPlaceArr: [
          { required: true, message: "请输入任职要求", trigger: "blur" },
        ],
      },
      loadingFlag: false,
      jobPositionNameList: [],
      jobTypeNameList: [],
      jobPlaceList: [],
    };
  },
  mounted() {
    let id = this.$route.query.id;
    if (id && id != 0) {
      this.$http.get(`/job-offers/baseGetById/${id}`).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          if (data.descStr) {
            this.descStrList = JSON.parse(data.descStr);
          }
          if (data.jobRequirements) {
            this.jobRequirementsList = JSON.parse(data.jobRequirements);
          }
          if (data.workPlace) data.workPlaceArr = data.workPlace.split(",");
          this.dataForm = res.data.data;
        }
      });
    } else {
      this.dataForm = {
        status: 1,
        top: true,
        // sort: 1,
      };
    }
    this.$http.get(`/job-position/getList`).then((res) => {
      if (res.data.code == 200) {
        this.jobPositionNameList = res.data.data;
      }
    });
    this.$http.get(`/job-type/getList`).then((res) => {
      if (res.data.code == 200) {
        this.jobTypeNameList = res.data.data;
      }
    });
    this.$http.get(`/sys-city/getCityName`).then((res) => {
      if (res.data.code == 200) {
        this.jobPlaceList = res.data.data;
      }
    });
  },
  methods: {
    deldescriptionListItem(index) {
      if (this.descStrList.length == 1) {
        this.$VueMessage({
          type: "info",
          message: "最少保留一项",
        });
        return;
      }
      this.$confirm("确定删除该信息?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.descStrList.splice(index, 1);
        })
        .catch(() => {
          this.$VueMessage({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deljobRequirementsListItem(index) {
      if (this.jobRequirementsList.length == 1) {
        this.$VueMessage({
          type: "info",
          message: "最少保留一项",
        });
        return;
      }
      this.$confirm("确定删除该信息?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.jobRequirementsList.splice(index, 1);
        })
        .catch(() => {
          this.$VueMessage({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /**
     * 上传图片成功
     */
    // uploadlistCover(res) {
    //   this.$store.state.beforeUploadLoading.close();
    //   this.$set(this.dataForm, "listCover", res.data);
    // },
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "/job-offers/saveOrUpdate";
          let data = this.dataForm;
          if (data.jobTypeId) {
            data.jobTypeName = this.jobTypeNameList.find((item) => {
              return item.id == data.jobTypeId;
            }).typeName;
          }
          if (this.descStrList.length > 0) {
            data.descStr = JSON.stringify(this.descStrList);
          } else data.descStr = [];
          if (data.jobPositionId) {
            data.jobPositionName = this.jobPositionNameList.find((item) => {
              return item.id == data.jobPositionId;
            }).name;
          }
          if (this.jobRequirementsList.length > 0) {
            data.jobRequirements = JSON.stringify(this.jobRequirementsList);
          } else data.jobRequirements = [];
          if (data.workPlaceArr.length > 0) {
            data.workPlace = data.workPlaceArr.join(",");
          } else data.workPlace = "";
          // this.$set(this.dataForm, "content", this.editor.txt.html());
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.$router.go(-1);
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-form {
  margin-top: 50px;
}

.btn {
  position: fixed;
  right: 60px;
}
</style>>
